export enum SubscriptionPlan {
  Pro = 'Pro',
  Enterprise = 'Enterprise',
  Free = 'Free',
  ProTierBased = 'ProTierBased',
  EnterpriseTierBased = 'EnterpriseTierBased',
}
